import { render, staticRenderFns } from "./CheckListField.vue?vue&type=template&id=35f272b5&scoped=true"
import script from "./CheckListField.vue?vue&type=script&lang=js"
export * from "./CheckListField.vue?vue&type=script&lang=js"
import style0 from "./CheckListField.vue?vue&type=style&index=0&id=35f272b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f272b5",
  null
  
)

export default component.exports